document.addEventListener("alpine:init", () => {
  Alpine.data("deliveryTiers", (options) => ({
    deliveryCountry: options.userCountry,
    shopCurrency: options.shopCurrency,
    currency: options.currency,
    shop: Shopify.shop,
    deliveryTiersApi: options.deliveryTiersApi,
    deliveryTiers: [],
    loading: true,

    init() {
      this.getDeliveryInfo();
    },

    getDeliveryInfo() {
      let country = this.deliveryCountry;

      if (!country) return;

      this.loading = true;
      this.$refs.countrySelect.selectedIndex = 0;

      let params = {
        country: this.deliveryCountry,
        shop: this.shop,
      };

      fetch(this.deliveryTiersApi, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify(params)
      })
      .then(response=>response.json())
      .then(data => { 
        this.deliveryTiers = data.deliveryTiers;
        this.countries = data.countries;

        if (this.deliveryTiers.length == 0) {
          this.$dispatch('updateUserLocation', { userLoc: window.shopIsoCode });
          this.deliveryCountry = window.shopIsoCode;
          this.getDeliveryInfo();
        } else {
          this.loading = false;
        }
      });
    },

    getTitle(tier) {
      let string;

      if (tier.maximumSpend === 0 && tier.minimumSpend === 0) {
        string = window.deliveryTierStrings.ordersAll;
      } else if (tier.maximumSpend === 0 && tier.minimumSpend > 0) {
        string = `${window.deliveryTierStrings.ordersOver} ${formatMoney(tier.minimumSpend*100, theme.moneyFormat)}`;
      } else {
        string = `${window.deliveryTierStrings.ordersBetween} ${formatMoney(tier.minimumSpend*100, theme.moneyFormat)} ${window.deliveryTierStrings.ordersAnd} ${formatMoney(tier.maximumSpend*100, theme.moneyFormat)}`;
      }

      return string.replace(/\.00/g, '').replace(/,00/g, '');
    },

    getDayString(option) {
      let string = `(${option.minDay} ${window.deliveryTierStrings.deliveryDay})`;
      
      if (option.minDay != option.maxDay) {
        string = `(${option.minDay} ${window.deliveryTierStrings.deliveryTo}
          ${option.maxDay} ${window.deliveryTierStrings.deliveryDays})`;
      }

      return string;
    },

    getPrice(option) {
      let price;

      price = option.price * Shopify.currency.rate;
      
      if (this.currency != this.shopCurrency) {
        price = Math.ceil(price);
      }

      if (price === 0) {
        price = window.deliveryTierStrings.deliveryFree;
      } else {
        price = `${formatMoney(price*100, theme.moneyFormat)}`;
      }

      return price;
    }
  }));
});